import { useEffect, useRef, useState } from 'react'
import cx from 'classnames'

import './style.scss'

const GoToTop = () => {
  const [showScrollToTopButton, setShowScrollToTopButton] = useState(false)
  const showScrollToTopButtonRef = useRef(showScrollToTopButton)

  const handleWindowScroll = () => {
    if (window.scrollY > 550 && !showScrollToTopButtonRef.current) {
      setShowScrollToTopButton(true)
    } else if (window.scrollY <= 550 && showScrollToTopButtonRef.current) {
      setShowScrollToTopButton(false)
    }
  }

  useEffect(() => {
    // scroll to top handler
    document.addEventListener('scroll', handleWindowScroll)

    return () => {
      // remove scroll to top handler
      document.removeEventListener('scroll', handleWindowScroll)
    }
  }, [])

  useEffect(() => {
    if (showScrollToTopButtonRef.current !== showScrollToTopButton) {
      showScrollToTopButtonRef.current = showScrollToTopButton
    }
  }, [showScrollToTopButton])

  return (
    <div
      className={cx('GoToTop', showScrollToTopButton && 'GoToTop--active')}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      role="button"
    />
  )
}

export default GoToTop
